import React from 'react';
import { PatternFormat } from 'react-number-format';
import { TextField } from '@mui/material';
import InputAdornment from '@mui/material/InputAdornment/InputAdornment';

type Props = any;

const NumberFormatTelAdapter = ({
  input: { onChange, inputRef, ...other },
  suffix,
  CustomInput,
  meta,
  ...rest
}: Props) => {
  const hasError = meta.touched && Boolean(meta.error);
  return (
    <PatternFormat
      {...rest}
      {...other}
      getInputRef={inputRef}
      onChange={onChange}
      customInput={CustomInput || TextField}
      format="(###) ###-##-##"
      placeholder="(___) ___-__-__"
      maxLength={10}
      InputProps={{
        startAdornment: <InputAdornment position="start">+7 </InputAdornment>,
        error: hasError,
      }}
    />
  );
};

NumberFormatTelAdapter.defaultProps = {
  suffix: ' ₽',
};

export default NumberFormatTelAdapter;
